import type { JSX } from 'react';

interface PlaceholderProps {
  surface: string;
  comingIn: string;
}

// Day 62a stub — every arbi-dev sidebar entry routes to this until the
// real surface is built (Days 62b–65). Renders a centered card showing
// the surface name and the deferred-day note.
export default function Placeholder({ surface, comingIn }: PlaceholderProps): JSX.Element {
  return (
    <div className="h-full overflow-auto">
      <div className="max-w-3xl mx-auto p-8">
        <div className="arbi-card p-8 space-y-3">
          <div className="text-xs uppercase tracking-wider text-ink-muted">arbi-dev</div>
          <h1 className="text-xl font-semibold text-ink-bright">{surface}</h1>
          <div className="text-sm text-ink-secondary">Coming in {comingIn}.</div>
        </div>
      </div>
    </div>
  );
}
